import React from 'react';
import classnames from 'classnames';
import { isNull, isUndefined } from 'lodash';

const Mark = ({ mark, className }) => {
	const cls = classnames(
		'w-7 h-7 flex items-center justify-center font-bold text-base text-center rounded-lg',
		(isNull(mark) || mark === '') && 'border border-neutral-200',
		(!isNull(mark) && mark !== ''&& mark < 4) && 'text-rose-500 border border-neutral-200',
		(mark >= 4 && mark < 7) && 'text-amber-500 border border-neutral-200',
		mark > 6 && 'text-emerald-500 border border-neutral-200',
		className
	);

	return (
		<div className={cls}>
			{mark}
		</div>
	);
};

export default Mark;